import { ActionIcon, Flex, Group, Stack, Text, Tooltip, useMantineColorScheme } from '@mantine/core';
import { IconHelpCircle, IconHome, IconMoon, IconSun } from '@tabler/icons-react';
import * as React from 'react';
import { ReactNode } from 'react';
import { When } from '../../../../react-commons/components/control-flow/When';
import { getDocumentationHost } from '../../resource/resource-base/APIVersion1';
import { useProCeedApplicationInformation } from '../../resource/services/useProCeedApplicationInformation';
import { TOOLTIPS } from '../../resource/tooltipTexts';

export const UnauthenticatedAppShell = ({ children }: { children: ReactNode }) => {
    const { toggleColorScheme, colorScheme } = useMantineColorScheme();

    const proceedVersion = useProCeedApplicationInformation();

    return (
        <Stack className={'window-root'}>
            <Group wrap={'nowrap'} h={40} p={6} bg={'primaryTeal'} justify={'space-between'}>
                <IconHome style={{ color: 'white' }} />
                <Group wrap={'nowrap'}>
                    <Tooltip label={TOOLTIPS.COLOR_SCHEME}>
                        <ActionIcon color="inherit" variant={'transparent'} size={'sm'} onClick={toggleColorScheme}>
                            <When expression={colorScheme} cases={{ dark: <IconSun /> }} fallback={<IconMoon />} />
                        </ActionIcon>
                    </Tooltip>
                    <Tooltip label={TOOLTIPS.DOCUMENTATION}>
                        <ActionIcon
                            color="inherit"
                            variant={'transparent'}
                            size={'sm'}
                            component={'a'}
                            target={'_blank'}
                            href={getDocumentationHost()}
                            rel={'noopener noreferrer'}
                        >
                            <IconHelpCircle />
                        </ActionIcon>
                    </Tooltip>
                </Group>
            </Group>
            <Flex flex={1} justify={'center'} align={'center'}>
                {children}
            </Flex>
            <span className={'footer'}>
                <span style={{ float: 'right', paddingRight: 5 }}>
                    <div style={{ display: 'inline-flex', alignItems: 'center', height: 24, paddingBottom: 3.5 }}>
                        <Text style={{ fontSize: 14, color: 'white', fontWeight: 450 }}>
                            ProCeed {proceedVersion.data?.applicationVersion}
                        </Text>
                    </div>
                </span>
            </span>
        </Stack>
    );
};
